import { render, staticRenderFns } from "./claimdetail.vue?vue&type=template&id=5d25ad59&scoped=true&"
import script from "./claimdetail.vue?vue&type=script&lang=ts&"
export * from "./claimdetail.vue?vue&type=script&lang=ts&"
import style0 from "./claimdetail.vue?vue&type=style&index=0&id=5d25ad59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25ad59",
  null
  
)

export default component.exports